import { areSimilarColors } from '../../../common/colors/colorComparisonUtil';
import { getIsLightColor } from '../../../common/colors/coreColorUtil';
import { getElementColorHexValue } from '../../../common/colors/elementColorFormatUtil';
import { getBackgroundColor } from '../../../common/elements/utils/elementPropertyUtils';
import {
    BACKGROUND_COLORS,
    ELEMENT_DEFAULT_BACKGROUND_DARK,
    ELEMENT_DEFAULT_BACKGROUND_LIGHT,
    LABEL_COLORS,
} from '../../../common/colors/colorConstants';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { Label } from '../../../common/labels/labelTypes';

export const getLabelOutlineProperties = (label: Label, element: ImMNElement, isDarkModeTheme: boolean) => {
    if (!label.color) return { hasSimilarColorToBackground: false, outlineColor: '' };

    const defaultBackground = isDarkModeTheme ? ELEMENT_DEFAULT_BACKGROUND_DARK : ELEMENT_DEFAULT_BACKGROUND_LIGHT;
    const elementColor = getBackgroundColor(element);

    const labelColorHex = getElementColorHexValue(label.color, LABEL_COLORS) ?? LABEL_COLORS.WHITE.hex;
    const elementColorHex = getElementColorHexValue(elementColor, BACKGROUND_COLORS) ?? defaultBackground;

    const hasSimilarColorToBackground = areSimilarColors(labelColorHex, elementColorHex);

    const outlineColor = getIsLightColor(labelColorHex)
        ? 'outline-border-black_alpha'
        : 'outline-border-white_alpha_alt';

    return { hasSimilarColorToBackground, outlineColor };
};
